module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    staticClass: "gv-button",
    attrs: {
      "id": "gv-button-switch3D",
      "title": "Switch3D"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46345130!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Switch3D.vue
// module id = 855
// module chunks = 39